import React from 'react'


const MerchantLandingLoadingStates = () => {
  return (
    <div className='landing_container'>
        <div className='landing_container_wrapper'>
        <div className='landing_section'>
       <div className="header_section">
        <div className="header_section_container">
            <div className='text_loaders merchant_landing_card_placeholder_loading'></div>
            <div className='text_loaders merchant_landing_card_placeholder_loading'></div>
        </div>
       </div>
       <div className='form_section'>
        <div className='form_section_placeholder'>
        <div className="form_section_container">
            <div className='form_section_loaders merchant_landing_card_placeholder_loading'></div>
            <div className='form_section_loaders merchant_landing_card_placeholder_loading'></div>
            <div className='form_section_loaders merchant_landing_card_placeholder_loading'></div>
        </div>
        </div>
       </div>
    </div>
    <div className={"merchant_landing_card_placeholder_loading landing_image_section"}>
       <div className='inner_box'></div>
    </div>
        </div>

    <style>
        {`
        .landing_container{
            height: 100vh;
        }
       .landing_container .landing_container_wrapper{
            display:flex;
            height: 100%;
        }
       .landing_container_wrapper .landing_section{
        flex-basis: 42%;
            display:flex;
            flex-direction:column;
        }

        .landing_image_section{
            flex-basis: 56%;
        }
     .landing_container_wrapper .landing_section .header_section{
      height: 155px;
        }

        .header_section_container{
            padding-left: 12%;
            padding-top: 3%;
            padding-bottom: 10%;
        }
        .form_section_container{
            display: flex;
            justify-content: center;
            align-items: flex-start;
            width: 60%;
            flex-direction: column;
            height: 100%;
        }

        .form_section_loaders{
            width: 100%;
            height: 8%;
            margin-block: 26px;
            border-radius: 10px;
        }

        .text_loaders{
            width: 25%;
            margin-block: 15px;
            border-radius: 10px;
            height: 25px;
        }
      .landing_section .form_section{
        flex-basis: 96%;
        background:#f1f3f7;
        display:flex;
        justify-content: center;
        align-items : center;
        padding: 20px;
        }

        .form_section_placeholder{
            width: 80%;
            height: 80%;
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;

        }

        .inner_box{
          margin-top: 21%;
          margin-left: 10%;
          background: white;
          border-radius: 5px;
          width: 200px;
          height: 142px;
        }
        
        .merchant_landing_card_placeholder_loading {
          animation: pulse 1s infinite ease-in-out;
        }
        @keyframes pulse {
          0% {
            background-color: rgba(165, 165, 165, 0.1)
          }
          50% {
            background-color: rgba(165, 165, 165, 0.3)
          }
          100% {
            background-color: rgba(165, 165, 165, 0.1)
          }
        }
        @media (max-width: 899px) {
          .landing_image_section{
            display:none;
          }

          .landing_container_wrapper .landing_section {
            flex-basis: 100%;
          }

          .header_section_container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;
          }

          .landing_container_wrapper .landing_section .header_section{
            flex-basis: 50%;
            }
            
            .header_section_container{
              padding:0;
            }
        }
        
        `}
    </style>
    </div>
  )
}

export default MerchantLandingLoadingStates